import { Link, useLocation } from "react-router-dom";
import logo from "../assets/images/avatar1.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faAngleRight,
  faBars,
  faCaretDown,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState, useRef } from "react";
import constants from "../constants/constants";
import formattingFunctions from "../functions/formatting";

export default function Header() {
  const [menus, setMenus] = useState({
    buying: false,
    selling: false,
    info: false,
    locations: false,
    contact: false
  });
  const [windowSize, setWindowSize] = useState(window.innerWidth);
  const [headerPosition, setHeaderPosition] = useState(100);
  const [headerTiming, setHeaderTiming] = useState(0.8);
  const location = useLocation();
  const [path, setPath] = useState(location.pathname);

  // Refs
  const headerRef = useRef(null);
  const lastScrollTopRef = useRef(0);

  const onWindowResize = () => {
    setWindowSize(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", onWindowResize);
    return () => {
      window.removeEventListener("resize", onWindowResize);
    };
  }, []);

  const setDropdown = (key, bool) => {
    setMenus((prevMenus) => ({
      ...prevMenus,
      ...Object.fromEntries(
        Object.keys(prevMenus).map((k) => [k, k === key ? bool : false])
      ),
    }));
  };

  const navClick = () => {
    setHeaderPosition(100);
    setHeaderTiming(0);
    setTimeout(() => {
      setHeaderTiming(0.8);
    }, 100);
    setMenus({ buying: false, selling: false, info: false, locations: false, contact: false });
  };

  useEffect(() => {
    setPath(location.pathname);
  }, [location]);

  const adjustHeader = () => {
    const st = window.scrollY;
    const header = headerRef.current;

    if (!header) return;

    if (st !== 0) {
      header.classList.add("transparent-black");
    } else if (location.pathname === "/") {
      header.classList.remove("transparent-black");
    }

    if (st > lastScrollTopRef.current) {
      header.classList.add("hide-header");
    } else if (st < lastScrollTopRef.current) {
      header.classList.remove("hide-header");
    }

    lastScrollTopRef.current = st <= 0 ? 0 : st;
  };

  useEffect(() => {
    window.addEventListener("scroll", adjustHeader);
    return () => {
      window.removeEventListener("scroll", adjustHeader);
    };
  }, [location, path]);

  return (
    <>
      {windowSize > 1350 ? (
        <div
          ref={headerRef}
          style={{ gridTemplateColumns: "1fr auto " }}
          className={`h-32 duration-700 w-full top-0 px-20 grid items-center libre fixed text-[#000] z-[100] shadow-lg ${path !== "/" ? "transparent-black" : "bg-white"
            }`}
        >
          <Link to={"/"}>
            <img src={constants.LOGO} className="h-20 py-3 self-center" alt="Logo" />
          </Link>
          <div
            style={{ fontWeight: "300", alignItems: "center" }}
            className="flex gap-x-10 text-xl"
          >
            <Link className="py-10" to={"/"}>
              Home
            </Link>
            {/* <Link className="py-10" to={"/about"}>
              About
            </Link> */}
            <Link className="py-10" to={"/services"}>
              Services
            </Link>
            {/* <div
              className="relative cursor-pointer py-10 font-light tracking-wide"
              onMouseEnter={() => setDropdown("locations", true)}
              onMouseLeave={() => setDropdown("locations", false)}
            >
              Locations{" "}
              <FontAwesomeIcon
                icon={faAngleDown}
                className={`ml-2 ${menus.locations ? "fa-flip-vertical" : ""}`}
              />
              {menus.locations && (
                <>
                  <div className="absolute z-10 top-full left-1/2 -translate-x-1/2 animate-slide-down text-logo-second bg-white child:p-4 child:text-center flex flex-col w-[250px] custom-box-shadow">
                    {constants.LOCATIONS.map((location) => (
                      <Link
                        className="hover:bg-logo-third hover:text-white"
                        to={`location/${formattingFunctions.slugify(
                          location.name
                        )}`}
                      >
                        {location.name}
                      </Link>
                    ))}
                  </div>
                </>
              )}
            </div> */}
            <div
              className="relative cursor-pointer py-10"
              onMouseEnter={() => setDropdown("buying", true)}
              onMouseLeave={() => setDropdown("buying", false)}
            >
              Buying{" "}
              <FontAwesomeIcon
                icon={faAngleDown}
                className={`ml-2 ${menus.buying ? "fa-flip-vertical" : ""}`}
              />
              {menus.buying && (
                <div className="absolute z-10 top-full left-1/2 -translate-x-1/2 animate-slide-down text-logo-second bg-white child:p-4 child:text-center flex flex-col w-[250px] custom-box-shadow">
                  <Link
                    className="hover:bg-logo-third hover:text-white"
                    to={"/calculator"}
                  >
                    Mortgage Calculator
                  </Link>
                  <Link
                    className="hover:bg-logo-third hover:text-white"
                    to={"/listings"}
                  >
                    Residential Search
                  </Link>
                  <Link
                    className="hover:bg-logo-third hover:text-white"
                    to={"/commercial"}
                  >
                    Commercial Search
                  </Link>
                  <Link
                    className="hover:bg-logo-third hover:text-white"
                    to={"/distressed-properties"}
                  >
                    Distressed Properties
                  </Link>
                  <Link
                    className="hover:bg-logo-third hover:text-white"
                    to={"/buying-guide"}
                  >
                    Guide for Buyers
                  </Link>
                </div>
              )}
            </div>
            <div
              className="relative cursor-pointer py-10"
              onMouseEnter={() => setDropdown("selling", true)}
              onMouseLeave={() => setDropdown("selling", false)}
            >
              Selling{" "}
              <FontAwesomeIcon
                icon={faAngleDown}
                className={`ml-2 ${menus.selling ? "fa-flip-vertical" : ""}`}
              />
              {menus.selling && (
                <div className="absolute z-10 top-full left-1/2 -translate-x-1/2 animate-slide-down text-logo-second bg-white child:p-4 child:text-center flex flex-col w-[250px] custom-box-shadow">
                  <Link
                    className="hover:bg-logo-third hover:text-white"
                    to={"/evaluation"}
                  >
                    Free Home Evaluation
                  </Link>
                  <Link
                    className="hover:bg-logo-third hover:text-white"
                    to={"/selling-guide"}
                  >
                    Guide for Sellers
                  </Link>
                </div>
              )}
            </div>
            <Link className="py-10"
              to={"https://www.aprem.ca/"}
              target="_blank"
              rel="noopener noreferrer">
              Property Management
            </Link>
            {/* <div
              className="relative cursor-pointer py-10"
              onMouseEnter={() => setDropdown("info", true)}
              onMouseLeave={() => setDropdown("info", false)}
            >
              Information{" "}
              <FontAwesomeIcon
                icon={faAngleDown}
                className={`ml-2 ${menus.info ? "fa-flip-vertical" : ""}`}
              />
              {menus.info && (
                <div className="absolute z-10 top-full left-1/2 -translate-x-1/2 animate-slide-down text-logo-second bg-white child:p-4 child:text-center flex flex-col w-[250px] custom-box-shadow">
                  <Link
                    className="hover:bg-logo-third hover:text-white"
                    to={"/real-estate-reports"}
                  >
                    Real Estate Reports
                  </Link>
                </div>
              )}
            </div> */}
            {/* <Link className="cursor-pointer py-10" to={"/contact"}>
              Contact
            </Link> */}
            <div
              className="relative cursor-pointer py-10"
              onMouseEnter={() => setDropdown("contact", true)}
              onMouseLeave={() => setDropdown("contact", false)}
            >
              About{" "}
              <FontAwesomeIcon
                icon={faAngleDown}
                className={`ml-2 ${menus.contact ? "fa-flip-vertical" : ""}`}
              />
              {menus.contact && (
                <div className="absolute z-10 top-full left-1/2 -translate-x-1/2 animate-slide-down text-logo-second bg-white child:p-4 child:text-center flex flex-col w-[250px] custom-box-shadow">
                  <Link
                    className="hover:bg-logo-third hover:text-white"
                    to={"/about"}
                  >
                    About Me
                  </Link>
                  <Link
                    className="hover:bg-logo-third hover:text-white"
                    to={"/testimonials"}
                  >
                    Testimonials
                  </Link>
                  <Link
                    className="hover:bg-logo-third hover:text-white"
                    to={"/contact"}
                  >
                    Contact
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="w-full h-32 px-6 z-30 flex justify-between items-center text-white absolute bg-white">
            <Link to={`/`}>
              <img src={constants.LOGO} className="w-24 object-cover" />
            </Link>
            <div
              style={{ backgroundColor: "#b87e58" }}
              className=" z-30 rounded-full h-10 w-10 flex items-center justify-center"
            >
              <FontAwesomeIcon
                onClick={() => {
                  setHeaderPosition(0);
                }}
                className="z-30 text-xl cursor-pointer "
                icon={faBars}
              />
            </div>
            {/* <div className="z-20 transition-opacity duration-700 ease-in-out w-full h-full absolute " />
            {headerPosition === 0 ? (
              <FontAwesomeIcon
                onClick={() => {
                  setHeaderPosition(100);
                }}
                className="z-30 text-2xl px-4 mx-4 cursor-pointer fixed right-4"
                icon={faXmark}
              />
            ) : (
              <div
                style={{ backgroundColor: "rgba(189, 144, 60, 0.3)" }}
                className=" z-30 rounded-full h-10 w-10 fixed right-7 flex items-center justify-center"
              >
                <FontAwesomeIcon
                  onClick={() => {
                    setHeaderPosition(0);
                  }}
                  className="z-30 text-xl cursor-pointer "
                  icon={faBars}
                />
              </div>
            )} */}
          </div>
          {headerPosition === 0 && (
            <div
              onClick={navClick}
              className="fixed inset-0 bg-black/40 z-20 transition-opacity"
            />
          )}
          <nav
            className={`fixed top-0 right-0 h-full w-full md:w-[400px] bg-logo-second z-50
            flex flex-col items-end gap-12 px-8 py-9 pt-12
            overflow-y-auto transition-transform duration-700 ease-in-out text-white 
            ${headerPosition === 0 ? "translate-x-0" : "translate-x-full"}`}
          >
            <div className="flex mb-16 w-full">
              <FontAwesomeIcon
                onClick={() => {
                  setHeaderPosition(100);
                }}
                className="z-30 text-3xl cursor-pointer px-3 py-1 bg-white/20 rounded"
                icon={faXmark}
              />
              <div className="w-full ">
                <img src={constants.LOGO} className="w-28 object-cover justify-self-center" />
              </div>
            </div>
            <Link
              onClick={() => {
                navClick();
              }}
              className={` ${path === "/" ? "active-page" : ""}`}
              to={"/"}
            >
              Home{" "}
              {path !== "/" ? (
                <FontAwesomeIcon className="pl-4" icon={faAngleRight} />
              ) : (
                ""
              )}
            </Link>
            {/* <Link
              onClick={() => {
                navClick();
              }}
              className={` ${path === "/about" ? "active-page" : ""}`}
              to={"/about"}
            >
              About{" "}
              {path !== "/about" ? (
                <FontAwesomeIcon className="pl-4" icon={faAngleRight} />
              ) : (
                ""
              )}
            </Link> */}
            <Link
              onClick={() => {
                navClick();
              }}
              className={` ${path === "/services" ? "active-page" : ""}`}
              to={"/services"}
            >
              Services{" "}
              {path !== "/services" ? (
                <FontAwesomeIcon className="pl-4" icon={faAngleRight} />
              ) : (
                ""
              )}
            </Link>
            {/* <span
              onClick={() => {
                setDropdown("locations", !menus.locations);
              }}
              className={`cursor-pointer`}
            >
              Locations{" "}
              {menus.locations ? (
                <FontAwesomeIcon className="pl-4" icon={faAngleDown} />
              ) : (
                <FontAwesomeIcon className="pl-4" icon={faAngleRight} />
              )}
            </span>
            {menus.locations && (
              <>
                {constants.LOCATIONS.map((location) => (
                  <Link
                    onClick={() => {
                      navClick();
                    }}
                    className={` ${path === formattingFunctions.slugify(location.name)
                      ? "active-page"
                      : ""
                      } text-slate-400`}
                    to={`location/${formattingFunctions.slugify(
                      location.name
                    )}`}
                  >
                    {location.name}{" "}
                    {path !== formattingFunctions.slugify(location.name) ? (
                      <FontAwesomeIcon className="pl-4" icon={faAngleRight} />
                    ) : (
                      ""
                    )}
                  </Link>
                ))}
              </>
            )} */}
            <span
              onClick={() => {
                setDropdown("buying", !menus.buying);
              }}
              className={`cursor-pointer`}
            >
              Buying{" "}
              {menus.buying ? (
                <FontAwesomeIcon className="pl-4" icon={faAngleDown} />
              ) : (
                <FontAwesomeIcon className="pl-4" icon={faAngleRight} />
              )}
            </span>
            {menus.buying && (
              <>
                <Link
                  onClick={() => {
                    navClick();
                  }}
                  className={` ${path === "/calculator" ? "active-page" : ""
                    } text-slate-400`}
                  to={"/calculator"}
                >
                  Mortgage Calculator{" "}
                  {path !== "/calculator" ? (
                    <FontAwesomeIcon className="pl-4" icon={faAngleRight} />
                  ) : (
                    ""
                  )}
                </Link>
                <Link
                  onClick={() => {
                    navClick();
                  }}
                  className={` ${path === "/listings" ? "active-page" : ""
                    }  text-slate-400`}
                  to={"/listings"}
                >
                  Listings{" "}
                  {path !== "/listings" ? (
                    <FontAwesomeIcon className="pl-4" icon={faAngleRight} />
                  ) : (
                    ""
                  )}
                </Link>
                <Link
                  onClick={() => {
                    navClick();
                  }}
                  className={` ${path === "/commercial" ? "active-page" : ""
                    }  text-slate-400`}
                  to={"/commercial"}
                >
                  Commercial Search{" "}
                  {path !== "/commercial" ? (
                    <FontAwesomeIcon className="pl-4" icon={faAngleRight} />
                  ) : (
                    ""
                  )}
                </Link>
                <Link
                  onClick={() => {
                    navClick();
                  }}
                  className={` ${path === "/distressed-properties" ? "active-page" : ""
                    }  text-slate-400`}
                  to={"/distressed-properties"}
                >
                  Distressed Properties{" "}
                  {path !== "/distressed-properties" ? (
                    <FontAwesomeIcon className="pl-4" icon={faAngleRight} />
                  ) : (
                    ""
                  )}
                </Link>
                <Link
                  onClick={() => {
                    navClick();
                  }}
                  className={` ${path === "/buying-guide" ? "active-page" : ""
                    }  text-slate-400`}
                  to={"/buying-guide"}
                >
                  Buying Guide{" "}
                  {path !== "/buying-guide" ? (
                    <FontAwesomeIcon className="pl-4" icon={faAngleRight} />
                  ) : (
                    ""
                  )}
                </Link>
              </>
            )}
            <span
              onClick={() => {
                setDropdown("selling", !menus.selling);
              }}
              className={`cursor-pointer`}
            >
              Selling{" "}
              {menus.selling ? (
                <FontAwesomeIcon className="pl-4" icon={faAngleDown} />
              ) : (
                <FontAwesomeIcon className="pl-4" icon={faAngleRight} />
              )}
            </span>
            {menus.selling && (
              <>
                <Link
                  onClick={() => {
                    navClick();
                  }}
                  className={` ${path === "/evaluation" ? "active-page" : ""
                    } text-slate-400`}
                  to={"/evaluation"}
                >
                  Free Home Evaluation{" "}
                  {path !== "/evaluation" ? (
                    <FontAwesomeIcon className="pl-4" icon={faAngleRight} />
                  ) : (
                    ""
                  )}
                </Link>
                <Link
                  onClick={() => {
                    navClick();
                  }}
                  className={` ${path === "/selling-guide" ? "active-page" : ""
                    } text-slate-400`}
                  to={"/selling-guide"}
                >
                  Selling Guide{" "}
                  {path !== "/evaluation" ? (
                    <FontAwesomeIcon className="pl-4" icon={faAngleRight} />
                  ) : (
                    ""
                  )}
                </Link>
              </>
            )}

            <Link
              onClick={() => {
                navClick();
              }}
              to={"https://www.aprem.ca/"}
              target="_blank"
              rel="noopener noreferrer"
            >
              Property Management{" "}

              <FontAwesomeIcon className="pl-4" icon={faAngleRight} />

            </Link>

            {/* <span
              onClick={() => {
                setDropdown("info", !menus.info);
              }}
              className={`cursor-pointer`}
            >
              Information{" "}
              {menus.info ? (
                <FontAwesomeIcon className="pl-4" icon={faAngleDown} />
              ) : (
                <FontAwesomeIcon className="pl-4" icon={faAngleRight} />
              )}
            </span>
            {menus.info && (
              <>
                <Link
                  onClick={() => {
                    navClick();
                  }}
                  className={` ${path === "/real-estate-reports" ? "active-page" : ""
                    } text-slate-400`}
                  to={"/real-estate-reports"}
                >
                  Free Real Estate Reports{" "}
                  {path !== "/real-estate-reports" ? (
                    <FontAwesomeIcon className="pl-4" icon={faAngleRight} />
                  ) : (
                    ""
                  )}
                </Link>
              </>
            )} */}
            {/* <Link
              onClick={() => {
                navClick();
              }}
              className={` ${path === "/contact" ? "active-page" : ""}`}
              to={"/contact"}
            >
              Contact{" "}
              {path !== "/contact" ? (
                <FontAwesomeIcon className="pl-4" icon={faAngleRight} />
              ) : (
                ""
              )}
            </Link> */}
            <span
              onClick={() => {
                setDropdown("contact", !menus.contact);
              }}
              className={`cursor-pointer`}
            >
              About{" "}
              {menus.contact ? (
                <FontAwesomeIcon className="pl-4" icon={faAngleDown} />
              ) : (
                <FontAwesomeIcon className="pl-4" icon={faAngleRight} />
              )}
            </span>
            {menus.contact && (
              <>
                <Link
                  onClick={() => {
                    navClick();
                  }}
                  className={` ${path === "/about" ? "active-page" : ""
                    } text-slate-400`}
                  to={"/about"}
                >
                  About Me{" "}
                  {path !== "/about" ? (
                    <FontAwesomeIcon className="pl-4" icon={faAngleRight} />
                  ) : (
                    ""
                  )}
                </Link>
                <Link
                  onClick={() => {
                    navClick();
                  }}
                  className={` ${path === "/testimonials" ? "active-page" : ""
                    } text-slate-400`}
                  to={"/testimonials"}
                >
                  Testimonials{" "}
                  {path !== "/testimonials" ? (
                    <FontAwesomeIcon className="pl-4" icon={faAngleRight} />
                  ) : (
                    ""
                  )}
                </Link>
                <Link
                  onClick={() => {
                    navClick();
                  }}
                  className={` ${path === "/contact" ? "active-page" : ""
                    } text-slate-400`}
                  to={"/contact"}
                >
                  Contact{" "}
                  {path !== "/contact" ? (
                    <FontAwesomeIcon className="pl-4" icon={faAngleRight} />
                  ) : (
                    ""
                  )}
                </Link>
              </>
            )}

          </nav>
        </>
      )}
    </>
  );
}
